import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import OrdersScreen from "../components/ordersScreen";

const AdminMenu = () => {
    const isAdmin = useSelector((state) => state.auth.isAdmin);
    const navigation = useNavigate()
    const isAdminStorage = sessionStorage.getItem("isAdmin");

    useEffect(() => {
    const isAdminStorage = sessionStorage.getItem("isAdmin");
      if(!(isAdmin || isAdminStorage === 'true')){
        navigation(-1);
      }
    },[]);

  return (isAdmin || isAdminStorage === 'true') && <OrdersScreen isAdmin/>
};

export default AdminMenu;
